import 'isomorphic-fetch'
import qs from 'qs'
import { push } from 'react-router-redux'
import {
  clearSearchFilters,
  setDraftFilter,
  setStatusFilter,
  setCourseFilter,
  setLevelFilter,
  setReviewTrackingStatus
} from './questsfilters'
import { postLoggingInfo } from './logging'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { getTotalCounts, getFilterQuery } from '../utils/productionstatus'
import { getTruncatedString } from '../utils/string'
import { reviewTracking } from '../constants/reviewtracking'

export const FETCH_PRODUCTION_STATUS_COUNTS_REQUEST =
  'FETCH_PRODUCTION_STATUS_COUNTS_REQUEST'
export const FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS =
  'FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS'
export const SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS =
  'SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS'

const fetchProductionStatusCountsRequest = () => ({
  type: FETCH_PRODUCTION_STATUS_COUNTS_REQUEST
})

const fetchProductionStatusCountsSuccess = counts => ({
  type: FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS,
  payload: {
    items: counts,
    totalCounts: getTotalCounts(counts)
  }
})

const setAllQuestsFiltersFromProductionStatusFilters = filterState => ({
  type: SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS,
  payload: {
    filterState
  }
})

const fetchProductionStatusCounts = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const orgId = state.organization.orgId
    const query = getFilterQuery(state.productionstatusfilters)
    const params = qs.stringify(
      {
        q: query
      },
      { arrayFormat: 'brackets', encode: false }
    )

    const url = `${getApiBaseUrlWithOrg(orgId)}/mock_levels/analytics?${params}`
    dispatch(fetchProductionStatusCountsRequest())
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const json = await response.json()
      dispatch(fetchProductionStatusCountsSuccess(json))
    } catch (e) {
      console.log(e)
    }
  }
}

const setAllQuestsFiltersAndNavigate = options => {
  return async (dispatch, getState) => {
    const state = getState()
    await dispatch(clearSearchFilters())
    await dispatch(
      setAllQuestsFiltersFromProductionStatusFilters(
        state.productionstatusfilters
      )
    )
    let loggingBody = {}
    if (options.status) {
      loggingBody.quest_status = options.status
      await dispatch(setAllQuestsStatusFiltersFromClickedStatus(options.status))
    }
    if (options.course) {
      loggingBody.intended_course = {
        id: options.course.course_id,
        name: options.course.course_name
      }
      await dispatch(
        setCourseFilter({
          id: options.course.course_id,
          value: options.course.course_id,
          label: getTruncatedString({
            val: options.course.course_name,
            len: 99999
          }),
          className: 'courseselect-option',
          style: {
            color: `#${options.course.color}`
          }
        })
      )
      // need to handle if a level filter is selected; while the filters here
      // were already merged with all quests filters, setting the course filter
      // above automatically clears the levels filters
      if (state.productionstatusfilters.mock_level_id_in.length > 0) {
        await dispatch(
          setLevelFilter(state.productionstatusfilters.mock_level_id_in)
        )
      }
    }
    if (options.level) {
      loggingBody.intended_level = {
        id: options.level.mock_level_id,
        name: options.level.name,
        number: options.level.number
      }
      await dispatch(setLevelFilter([options.level.mock_level_id]))
    }
    dispatch(push('/quests'))
    dispatch(
      postLoggingInfo('quest_production_status', {
        action: 'count_click',
        ...loggingBody
      })
    )
  }
}

const setAllQuestsStatusFiltersFromClickedStatus = selectedStatus => {
  return dispatch => {
    if (selectedStatus === 'draft') {
      dispatch(setDraftFilter(1))
      dispatch(setStatusFilter([]))
    } else if (selectedStatus === 'review returned') {
      dispatch(setStatusFilter([2]))
    } else if (selectedStatus === 'quality review') {
      dispatch(setStatusFilter([0, 4]))
    } else if (selectedStatus === 'copy edit') {
      dispatch(setDraftFilter(1))
      dispatch(setStatusFilter([]))
      dispatch(
        setReviewTrackingStatus(
          reviewTracking.find(rt => rt.backend_value === 'in_copy_edit')
        )
      )
    } else if (selectedStatus === 'exp/sub') {
      dispatch(setDraftFilter(1))
      dispatch(setStatusFilter([]))
      dispatch(
        setReviewTrackingStatus(
          reviewTracking.find(rt => rt.backend_value === 'in_internal_review')
        )
      )
    } else {
      dispatch(setStatusFilter([5]))
    }
  }
}

const postViewInfoToLogging = () => dispatch => {
  dispatch(
    postLoggingInfo('quest_production_status', {
      action: 'view_all'
    })
  )
}

const logLevelsExpandClick = course => dispatch => {
  dispatch(
    postLoggingInfo('quest_production_status', {
      action: 'level_view',
      intended_course: {
        id: course.course_id,
        name: course.course_name
      }
    })
  )
}

export {
  fetchProductionStatusCountsRequest,
  fetchProductionStatusCountsSuccess,
  fetchProductionStatusCounts,
  setAllQuestsFiltersAndNavigate,
  postViewInfoToLogging,
  logLevelsExpandClick,
  setAllQuestsFiltersFromProductionStatusFilters,
  setAllQuestsStatusFiltersFromClickedStatus
}



// WEBPACK FOOTER //
// ./src/actions/productionstatus.js